import {IntlShape} from "react-intl"


export const familiesHeader = (intl: IntlShape) => {
    return {
        id: intl.formatMessage({ id: "creator.column.family.id" }).toLowerCase(),
        enabled: intl.formatMessage({ id: "creator.column.family.enabled" }).toLowerCase(),
        husbandId: intl.formatMessage({ id: "creator.column.family.husbandId" }).toLowerCase().replace(/\s+/g, "_"),
        wifeId: intl.formatMessage({ id: "creator.column.family.wifeId" }).toLowerCase().replace(/\s+/g, "_"),
        marriageDate: intl.formatMessage({ id: "creator.column.family.marriageDate" }).toLowerCase().replace(/\s+/g, "_"),
        marriagePlace: intl.formatMessage({ id: "creator.column.family.marriagePlace" }).toLowerCase().replace(/\s+/g, "_"),
        notes: intl.formatMessage({ id: "creator.column.family.notes" }).toLowerCase(),
        ...{ __SEP__: "" },
        // GEDCOM bindings
        children: intl.formatMessage({ id: "creator.extras.children" }).toLowerCase()
    }
}